import { useRegisterSW } from 'virtual:pwa-register/react';
import { RefreshCw, X } from 'lucide-react';

/**
 * Muestra un botón flotante cuando hay una nueva versión de la app disponible.
 * Resuelve el problema de usuarios que quedan con la versión anterior en caché:
 * el service worker descarga la nueva versión en segundo plano y, al estar lista,
 * aparece este aviso para que la persona refresque con un clic.
 */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      // Revisar si hay nueva versión cada 30 minutos (sesiones largas en fábrica)
      if (registration) {
        setInterval(() => {
          registration.update();
        }, 30 * 60 * 1000);
      }
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] w-[calc(100%-2rem)] max-w-md">
      <div className="flex items-center gap-3 rounded-xl bg-green-600 px-4 py-3 text-white shadow-lg">
        <RefreshCw className="h-5 w-5 flex-shrink-0" />
        <span className="flex-1 text-sm font-medium">Hay una nueva versión disponible</span>
        <button
          onClick={() => updateServiceWorker(true)}
          className="rounded-lg bg-white px-3 py-1.5 text-sm font-semibold text-green-700 hover:bg-green-50"
        >
          Actualizar
        </button>
        <button
          onClick={() => setNeedRefresh(false)}
          className="rounded-lg p-1 text-white/80 hover:bg-green-700 hover:text-white"
          title="Después"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
